import React from 'react';
import { T } from 'shared/helper/translate';
import { TRIAL_PLAN, formatAmount, intervalLabel, planLabel } from 'rubriq/helpers/emailCheckoutSummary';

/**
 * The left-hand side of the pay page: the plan being checked out as its heading, what it costs
 * and what happens next. Paddle's frame beside it only takes the card details.
 *
 * With a `plan`, the checkout subscribes to it straight away, replacing the free trial. Without
 * one, it adds a payment method to the trial, which carries on and then bills editing monthly.
 */
var EmailCheckoutSummary = function EmailCheckoutSummary(_ref) {
  var _ref$plan = _ref.plan,
    plan = _ref$plan === void 0 ? null : _ref$plan,
    _ref$interval = _ref.interval,
    interval = _ref$interval === void 0 ? null : _ref$interval,
    _ref$prices = _ref.prices,
    prices = _ref$prices === void 0 ? null : _ref$prices,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en' : _ref$locale;
  var subscribing = Boolean(plan);
  var shown = subscribing ? {
    plan: plan,
    interval: interval || 'yearly'
  } : TRIAL_PLAN;
  var period = (prices === null || prices === void 0 ? void 0 : prices.interval) || shown.interval;
  var amount = function amount(value) {
    return formatAmount(value, prices.currency, locale);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "card shadow-sm h-100",
    "data-testid": "email-checkout-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body p-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Rubriq"
  })), /*#__PURE__*/React.createElement("h1", {
    className: "h3 mb-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: planLabel(shown.plan)
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-4"
  }, /*#__PURE__*/React.createElement(T, {
    source: intervalLabel(period)
  })), !prices && /*#__PURE__*/React.createElement("div", {
    className: "spinner-border spinner-border-sm text-primary mb-4",
    "aria-hidden": "true"
  }), prices && /*#__PURE__*/React.createElement("dl", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("dt", {
    className: "fw-normal"
  }, /*#__PURE__*/React.createElement(T, {
    source: period === 'yearly' ? 'Price per year' : 'Price per month'
  })), /*#__PURE__*/React.createElement("dd", {
    className: "mb-2"
  }, amount(prices.recurring))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between fw-bold border-top pt-2"
  }, /*#__PURE__*/React.createElement("dt", null, /*#__PURE__*/React.createElement(T, {
    source: "Due today"
  })), /*#__PURE__*/React.createElement("dd", {
    className: "mb-0"
  }, amount(prices.dueToday))), prices.tax > 0 && /*#__PURE__*/React.createElement("p", {
    className: "small text-muted mt-1 mb-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Includes tax of %(tax)s",
    params: {
      tax: amount(prices.tax)
    }
  }))), /*#__PURE__*/React.createElement("h2", {
    className: "h6"
  }, /*#__PURE__*/React.createElement(T, {
    source: "What happens next"
  })), /*#__PURE__*/React.createElement("ul", {
    className: "small ps-3 mb-0"
  }, subscribing ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, {
    source: "%(plan)s starts as soon as you subscribe, and replaces your free trial.",
    params: {
      plan: planLabel(shown.plan)
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, {
    source: period === 'yearly' ? 'It renews every year until you cancel.' : 'It renews every month until you cancel.'
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, {
    source: "Nothing is charged today. Your free trial carries on until it ends."
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, {
    source: "Then Premium Editing continues every month until you cancel."
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(T, {
    source: "Your documents and edit history are kept."
  })))));
};
export default EmailCheckoutSummary;